import { AdditionalRateType } from 'src/app/recruiting/locums-margin-calculator/models/additional-rate-type.models';
import { AdditionalRates } from 'src/app/recruiting/locums-margin-calculator/models/additional-rates.models';
import { MarginCoverageTypes } from 'src/app/recruiting/locums-margin-calculator/models/margin-coverage-types.models';

export interface AdditionalRatesSlice {
    readonly additionalRateTypes: AdditionalRateType[];
    readonly marginCoverageTypes: MarginCoverageTypes[];
    readonly additionalRates: AdditionalRates[];
}

export const initialAdditionalRatesSlice: AdditionalRatesSlice = {
    additionalRateTypes: [],
    marginCoverageTypes: [],
    additionalRates: []
};
